import { Divider, Text } from "@ui-kitten/components";
import ContactUs from "screens/Barcode/components/ContactUs";
import EventNoticeIcon from "components/EventNoticeIcon";
import MainContainer from "components/MainContainer";
import RenderHtmlComponent from "components/RenderHtml";
import { EventDetails, TicketDetails } from "features/types";
import React from "react";
import { View, Modal, ScrollView, Pressable } from "react-native";
import ticketBackText from "./ticketBackText";
import i18n from "plugins/localization";
import { formatEventDate } from "utils/eventUtils";

interface TickBackModalProps {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  tickets: TicketDetails[];
  event: EventDetails;
  currentIndex: number;
}

const DetailItem: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <View style={{ paddingHorizontal: 8, marginVertical: 10 }}>
    <View>{children}</View>
  </View>
);
const TicketBackModal: React.FC<TickBackModalProps> = ({
  visible,
  setVisible,
  tickets,
  event,
  currentIndex,
}) => {
  const ticket = tickets[currentIndex];
  const ticketNotices = event.notices.filter(
    (notice) => notice.displayTypes.indexOf("TICKET") > 0
  );

  if (ticket === undefined) {
    return null;
  }
  const {
    event: { tenantSubdomain },
  } = ticket;

  const tenantTicketBackText: string | undefined =
    ticketBackText(tenantSubdomain);

  return (
    <Modal style={{ flex: 1 }} visible={visible} animationType="slide">
      <MainContainer
        // @ts-ignore
        accessoryRight={
          <Pressable onPress={() => setVisible(false)}>
            <Text style={{ fontWeight: "700", color: "white" }}>
              {i18n.t("screens.Barcode.done")}
            </Text>
          </Pressable>
        }
        showLeftAction={false}
      >
        <ScrollView style={{ paddingTop: 10 }}>
          <View
            style={{
              alignItems: "center",
              justifyContent: "center",
              paddingHorizontal: 8,
            }}
          >
            <Text style={{ fontSize: 24, fontWeight: "700" }}>
              {event.name}
            </Text>
            <Text style={{ fontSize: 16 }}>{formatEventDate(event)}</Text>
          </View>
          <Divider />
          <DetailItem>
            <Text>{i18n.t("screens.Barcode.barcodeNumber") as string}</Text>
            <Text category="h6">{ticket.barcodeString}</Text>
          </DetailItem>
          <Divider />
          <DetailItem>
            <Text>{i18n.t("screens.Barcode.seatInfo") as string}</Text>
            <Text category="h6">
              {i18n.t("common.section") as string}: {ticket.seat.sectionDisplay}{" "}
              / {i18n.t("common.row") as string}: {ticket.seat.rowDisplay} /
              {i18n.t("common.seat", { count: 1 }) as string}:{" "}
              {ticket.seat.seatDisplay}
            </Text>
          </DetailItem>
          <Divider />
          <DetailItem>
            <ContactUs />
          </DetailItem>
          <Divider />
          {ticketNotices.length > 0 && (
            <DetailItem>
              <Text category="h4">
                {i18n.t("screens.Barcode.importantNotices") as string}
              </Text>
              {ticketNotices.map((notice) => (
                <View key={notice.id}>
                  <View
                    key={notice.id}
                    style={{ flexDirection: "row", alignItems: "center" }}
                  >
                    <EventNoticeIcon type={notice.type} size={15} />
                    <Text style={{ marginLeft: 5 }}>{notice.tag}</Text>
                  </View>
                  <RenderHtmlComponent
                    source={notice.description}
                  ></RenderHtmlComponent>
                </View>
              ))}
            </DetailItem>
          )}
          {tenantTicketBackText && (
            <DetailItem>
              <RenderHtmlComponent
                source={tenantTicketBackText}
              ></RenderHtmlComponent>
            </DetailItem>
          )}
        </ScrollView>
      </MainContainer>
    </Modal>
  );
};

export default TicketBackModal;
